import type { DemoConfig } from '@magic/slot';
import { baseRound } from './rounds/base';
import { freeSpinsRound } from './rounds/freeSpins';
import { linesRound } from './rounds/lines';
import { waysRound } from './rounds/ways';

/**
 * Canned rounds this game replays when it runs without a real session. Switch
 * `activeRound` below to serve a different one from every spin.
 */
const rounds = {
    base: baseRound,
    freeSpins: freeSpinsRound,
    lines: linesRound,
    ways: waysRound,
};

export const demoConfig: DemoConfig = {
    rounds,
    activeRound: 'freeSpins',
    initState: {
        balance: {
            amount: 1000000000,
            currency: 'USD',
        },
        config: {
            minBet: 1,
            maxBet: 10,
            stepBet: 1,
            // Default bet amount (raw units). Displayed as defaultBetLevel / 1_000_000,
            // so 1_000_000 renders as a bet of 1. Must be one of betLevels.
            defaultBetLevel: 1000000,
            // Raw units; displayed as level / 1_000_000, so these render as bets 1..10.
            betLevels: [
                1000000, 2000000, 3000000, 4000000, 5000000, 6000000, 7000000, 8000000, 9000000,
                10000000,
            ],
        },
        // Bet modes the RGS offers. The non-base one is what the shop sells, at
        // `bet * costMultiplier` — so free spins cost 40x the bet here.
        gameModes: [
            { mode: 'BASE', costMultiplier: 1, maxBet: 1000000000 },
            { mode: 'FREESPINS', costMultiplier: 40, maxBet: 1000000000 },
        ],
        jurisdictionFlags: {
            socialCasino: true,
            disabledFullscreen: true,
            disabledTurbo: true,
            disabledSuperTurbo: true,
            disabledAutoplay: true,
            disabledSlamstop: true,
            disabledSpacebar: true,
            disabledBuyFeature: true,
            displayNetPosition: true,
            displayRTP: true,
            displaySessionTimer: true,
            minimumRoundDuration: 10000,
        },
        round: {
            betID: 0,
            active: true,
            mode: 'BASE',
            state: rounds.base,
        },
    },
};
